import pacote from "../../../../package.json" with { type: "json" };

/** Versão do sistema (o "version" do package.json da raiz, embutido no build). */
export const VERSAO: string = pacote.version;
